export const typography = {
  fontFamily: 'Poppins, Domine',
  h1: {
    fontFamily: 'Poppins',
    fontSize: 32,
    lineHeight: 1.5,
    fontWeight: 600,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 48,
      lineHeight: 1.15,
    },
  },
  h2: {
    fontFamily: 'Poppins',
    fontSize: 26,
    lineHeight: 1.5,
    fontWeight: 500,
    textAlign: 'left',
    '@media (min-width:900px)': {
      lineHeight: 1.15,
      fontSize: 34,
    },
  },
  'h2-bold': {
    fontFamily: 'Poppins',
    fontSize: 26,
    fontWeight: 600,
    lineHeight: 1.5,
    textAlign: 'left',
    '@media (min-width:900px)': {
      lineHeight: 1.15,
      fontSize: 34,
    },
  },
  subtitle1: {
    fontFamily: 'Poppins',
    fontSize: 20,
    lineHeight: 1.5,
    fontWeight: 500,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 24,
      lineHeight: 1.15,
    },
  },
  'subtitle1-bold': {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.5,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 24,
      lineHeight: 1.15,
    },
  },
  h5: {
    fontFamily: 'Domine',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1.15,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 20,
    },
  },
  body1: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.15,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 18,
    },
  },
  body2: {
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.15,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 16,
    },
  },
  'body2-bold': {
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1.15,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 16,
    },
  },
  button: {
    fontFamily: 'Poppins',
    fontSize: 15,
    lineHeight: 1.5,
    fontWeight: 600,
    textTransform: 'none',
    textAlign: 'center',
    '@media (min-width:900px)': {
      fontSize: 18,
      lineHeight: 1.15,
    },
  },
  caption: {
    fontFamily: 'Domine',
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1.15,
    textAlign: 'left',
    '@media (min-width:900px)': {
      fontSize: 16,
    },
  },
  overline: {
    fontFamily: 'Poppins',
    fontSize: 8,
    fontWeight: 400,
    textAlign: 'left',
    textTransform: 'unset',
    lineHeight: 1.5,
    '@media (min-width:900px)': {
      fontSize: 12,
    },
  },
};
